
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';


import { Link } from "react-router-dom";
import holland from "../../assets/holland.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"

function HollandMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Holland magyar fordító</title>
                <meta name='description' content="Ingyenes holland magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Holland magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/holland-magyar-fordito" />
            </Helmet>
            <h1>Holland magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A holland nyelvről</h2>
                    <img src={holland} alt="Holland zászló"></img>
                </div>


                <p>A holland egy nyugat-germán nyelv, amelyet körülbelül 24 millió ember beszél anyanyelvként. Hollandia hivatalos nyelve, valamint Belgium és Suriname egyik hivatalos nyelve. A holland nyelvet Németország és a Karib-térség egyes részein is beszélik.</p>

                <p>A nyelv hasonlóságokat mutat más germán nyelvekkel, például az angollal és a némettel. Viszonylag egyszerű nyelvtannal és gutturális és lágyabb hangokból álló hangrendszerrel rendelkezik. A holland a latin ábécét használja, néhány további karakterrel és diakritikus jelekkel kiegészítve.</p>

                <p>A holland szókincset különböző tényezők befolyásolják, beleértve a más nyelvekkel való történelmi kapcsolatokat is. Többek között francia, latin és angol kölcsönszavakat tartalmaz. A holland szavakkal is hozzájárult az angol nyelvhez, különösen olyan területeken, mint a kereskedelem, a művészet és a tengerészeti terminológia.</p>

                <p>Nyelvtanában vannak nyelvtani nemek, a főnevek hím-, nőnemű vagy alanyi nemet kapnak. A melléknevek és a névelők megegyeznek az általuk módosított főnév nemével és számával. Az igék ragozása az idő, a mód és az alany szerint történik.</p>

                <p>A holland nyelvjárások különböző régiókban léteznek, és eltérések vannak a szókincsben, a kiejtésben, sőt még a nyelvtanban is. A holland nyelv standard formája, az Algemeen Beschaafd Nederlands (standard holland), amelyet hivatalos környezetben, az oktatásban és a médiában használnak.</p>

                <p>A holland nyelv elsajátítása megnyitja az utat a holland irodalom felé, beleértve olyan neves szerzők műveit, mint Anne Frank és Harry Mulisch. Emellett hozzáférést biztosít a holland kultúrához, történelemhez, valamint Hollandia és Belgium élénk művészeti életéhez.</p>

                <p>A holland nyelvtudás értékes az üzleti és kereskedelmi életben érdekeltek számára, mivel Hollandia nemzetközi kereskedelméről és többnyelvű munkaerőjéről ismert. A holland nyelv emellett megkönnyíti a kommunikációt a holland nyelvű közösségekkel szerte a világon.</p>
          
                <div className="sectionbottom">
                    <Link to="/magyar-holland-fordito">Magyar holland fordító</Link>

                    <img src={holland} alt="holland zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>
          
          
            </section>
        </>

    )
}

export default HollandMagyar;